export type JsonParseResult =
  | { ok: true; value: unknown }
  | { ok: false; error: string };

export const isBlank = (text?: string | null): boolean =>
  !text || text.trim().length === 0;

export const parseJson = (text: string): JsonParseResult => {
  try {
    return { ok: true, value: JSON.parse(text) };
  } catch (error) {
    return {
      ok: false,
      error: error instanceof Error ? error.message : 'JSON inválido',
    };
  }
};

export const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

/** Los headers viajan como Record<string, string>: normalizamos los valores. */
export const toStringRecord = (
  value: Record<string, unknown>
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(value).map(([key, item]) => [key, String(item)])
  );

export const stringifyJson = (value: unknown): string => {
  if (value === undefined || value === null) return '';
  if (typeof value === 'string') return value;
  return JSON.stringify(value, null, 2);
};
